import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { premiumServicesList, PremiumServiceItem } from 'constants/premium-service-constants';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { useMediaQuery } from 'react-responsive';
import { LayoutContext } from 'components/app-routes';
import { addAgentCode } from '__utils/common-utils';

const PremiumServicesListCont = styled.div`
    box-shadow: 0 2px 4px 0 ${COLOR.LIGHTGREY};
`;

const PremiumServicesListItemCont = styled.div`
    padding: 0px 15px;
    background-color: ${COLOR.WHITE};
    .inner-content {
        padding: 15px 0px;
        display: flex;
    }
    img {
        height: 48px;
    }
    .text {
        flex: 1;
        padding-left: 10px;
    }
    .title {
        font-size: 14px;
        font-weight: 600;
        line-height: normal;
        color: ${COLOR.BLACK};
        margin-bottom: 4px;
    }
    .desc {
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: ${COLOR.GREY};
    }
    i {
        color: ${COLOR.GREEN};
        font-size: 25px;
    }
`;

const PremiumServices: React.FC = () => {

    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        // redirect to not found since premium services is not built for desktop
        if (!isMobile)
        {
            window.location.href = window.location.origin + '/v1/home?url=404';
        }
        SetLayoutProps({
            config: { title: 'Premium Services' },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Premium Services', url: '' } ]
        })
    }, []);

    const premiumServicesDetailClick = (premiumServicesItem: PremiumServiceItem) => {
        Mixpanel.track(getEventName("viewPremiumServices", "clicked"), {
            agentCode: getAgentCode(),
            type: premiumServicesItem.route,
            user: getUserDetails()
        });
        history.push("/premium-service-details/" + premiumServicesItem.route);
    };

    return (
        <PremiumServicesListCont>
            { premiumServicesList.map((premiumServicesItem: PremiumServiceItem, i: number) =>
                <PremiumServicesListItemCont
                    key={ i }
                    onClick={ () => premiumServicesDetailClick(premiumServicesItem) }
                >
                    <div className="inner-content" style={ { borderBottom: i < (premiumServicesList?.length - 1) ? '1px solid lightgrey' : 'none' } }>
                        <img src={ `../v1/img/${premiumServicesItem.icon}` } alt="search" />
                        <div className="text">
                            <p className="title">{ premiumServicesItem.title }</p>
                            <p className="desc">{ premiumServicesItem.shortDescription }</p>
                        </div>
                        <i className="icon-arrow_right"></i>
                    </div>
                </PremiumServicesListItemCont>
            ) }
        </PremiumServicesListCont>
    );
};

export default PremiumServices;
